import { memo } from 'react'
import { Navigate, useLocation, useNavigate } from 'react-router-dom'

import { Box, Title } from '@factorialco/deprecated-design-system'

import { useNavigation } from 'modules/core/hooks/useNavigation'
import i18n from 'modules/core/lib/i18n'
import companies from 'modules/core/store/collections/companies'

import { navigateRoot } from 'modules/authentication/components/_CompanySwitcher'
import CompanySelector from 'modules/authentication/components/_CompanySwitcher/CompanySelector'

function CompanySelectorPage() {
  const { navigation } = useNavigation()
  const navigate = useNavigate()
  const location = useLocation()

  const returnTo = location.state?.returnTo
  const handleChoice = returnTo ? () => navigate(returnTo) : navigateRoot

  if (companies.selected) return <Navigate to={navigation.path} />

  return (
    <Box width="full" height="full" alignItems="center" justifyContent="center">
      <Box width="s600" alignItems="center" justifyContent="center">
        <Box maxWidth="s400" textAlign="center">
          <Title
            title={i18n.t('authentication.company_selector.title')}
            illustration="logo-avatar"
            centered
            description={i18n.t('authentication.company_selector.description')}
          />
        </Box>
        <CompanySelector isFullPage onChoose={handleChoice} />
      </Box>
    </Box>
  )
}

export default memo(CompanySelectorPage)
